import { RegionShared } from "@1games-ru/region-shared";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default () => {
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Vehicle.SetSpeedometerShow,
      ({ isShowed }: typeof RegionShared.Cef.Requests.SetSpeedometerShowRequest): void => {
        setIsShow(isShowed);
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Vehicle.SetSpeedometerShow);
    };
  }, []);

  return {
    isShow,
  };
};
